/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as MasterRouteImport } from './routes/master'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MasterLoginRouteImport } from './routes/master.login'
import { Route as AuthedWorkshopRouteImport } from './routes/_authed/workshop'
import { Route as AuthedWarrantiesRouteImport } from './routes/_authed/warranties'
import { Route as AuthedUsersRouteImport } from './routes/_authed/users'
import { Route as AuthedTransfersRouteImport } from './routes/_authed/transfers'
import { Route as AuthedSuppliersRouteImport } from './routes/_authed/suppliers'
import { Route as AuthedSalesReturnsRouteImport } from './routes/_authed/sales-returns'
import { Route as AuthedSalesRouteImport } from './routes/_authed/sales'
import { Route as AuthedReportsRouteImport } from './routes/_authed/reports'
import { Route as AuthedReceivablesRouteImport } from './routes/_authed/receivables'
import { Route as AuthedQuotationsRouteImport } from './routes/_authed/quotations'
import { Route as AuthedPurchasesRouteImport } from './routes/_authed/purchases'
import { Route as AuthedPromotionsRouteImport } from './routes/_authed/promotions'
import { Route as AuthedPrintingRouteImport } from './routes/_authed/printing'
import { Route as AuthedPosRouteImport } from './routes/_authed/pos'
import { Route as AuthedPaymentMethodsRouteImport } from './routes/_authed/payment-methods'
import { Route as AuthedPayablesRouteImport } from './routes/_authed/payables'
import { Route as AuthedInventoryTransferRequestsRouteImport } from './routes/_authed/inventory-transfer-requests'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AuthedCustomersRouteImport } from './routes/_authed/customers'
import { Route as AuthedCommissionsRouteImport } from './routes/_authed/commissions'
import { Route as AuthedCashRegisterRouteImport } from './routes/_authed/cash-register'
import { Route as AuthedInventoryIndexRouteImport } from './routes/_authed/inventory/index'
import { Route as AuthedImportIndexRouteImport } from './routes/_authed/import/index'
import { Route as AuthedUsersUserIdRouteImport } from './routes/_authed/users/$userId'
import { Route as AuthedTransfersTransferIdRouteImport } from './routes/_authed/transfers/$transferId'
import { Route as AuthedSettingsTelegramRouteImport } from './routes/_authed/settings/telegram'
import { Route as AuthedSettingsCompanyRouteImport } from './routes/_authed/settings/company'
import { Route as AuthedSettingsCapabilitiesRouteImport } from './routes/_authed/settings/capabilities'
import { Route as AuthedQuotationsQuotationIdRouteImport } from './routes/_authed/quotations.$quotationId'
import { Route as AuthedPosArmarRouteImport } from './routes/_authed/pos_.armar'
import { Route as AuthedInventoryManualMovementsRouteImport } from './routes/_authed/inventory/manual-movements'
import { Route as AuthedInventoryCurrencyRouteImport } from './routes/_authed/inventory/currency'
import { Route as AuthedInventoryCatalogsRouteImport } from './routes/_authed/inventory/catalogs'
import { Route as AuthedInventoryAdminRouteImport } from './routes/_authed/inventory/admin'
import { Route as AuthedInventoryProductIdRouteImport } from './routes/_authed/inventory/$productId'
import { Route as AuthedInventoryTransferRequestsRequestIdRouteImport } from './routes/_authed/inventory-transfer-requests/$requestId'
import { Route as AuthedAccessRolesRouteImport } from './routes/_authed/access/roles'
import { Route as AuthedAccessPermissionsRouteImport } from './routes/_authed/access/permissions'
import { Route as AuthedAccessGroupsRouteImport } from './routes/_authed/access/groups'
import { Route as AuthedImportSessionsSessionIdRouteImport } from './routes/_authed/import/sessions/$sessionId'
import { Route as AuthedAccessRolesRoleIdRouteImport } from './routes/_authed/access/roles/$roleId'

const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const MasterRoute = MasterRouteImport.update({
  id: '/master',
  path: '/master',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MasterLoginRoute = MasterLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => MasterRoute,
} as any)
const AuthedWorkshopRoute = AuthedWorkshopRouteImport.update({
  id: '/workshop',
  path: '/workshop',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedWarrantiesRoute = AuthedWarrantiesRouteImport.update({
  id: '/warranties',
  path: '/warranties',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUsersRoute = AuthedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTransfersRoute = AuthedTransfersRouteImport.update({
  id: '/transfers',
  path: '/transfers',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSuppliersRoute = AuthedSuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSalesReturnsRoute = AuthedSalesReturnsRouteImport.update({
  id: '/sales-returns',
  path: '/sales-returns',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSalesRoute = AuthedSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReportsRoute = AuthedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReceivablesRoute = AuthedReceivablesRouteImport.update({
  id: '/receivables',
  path: '/receivables',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedQuotationsRoute = AuthedQuotationsRouteImport.update({
  id: '/quotations',
  path: '/quotations',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPurchasesRoute = AuthedPurchasesRouteImport.update({
  id: '/purchases',
  path: '/purchases',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPromotionsRoute = AuthedPromotionsRouteImport.update({
  id: '/promotions',
  path: '/promotions',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPrintingRoute = AuthedPrintingRouteImport.update({
  id: '/printing',
  path: '/printing',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPosRoute = AuthedPosRouteImport.update({
  id: '/pos',
  path: '/pos',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPaymentMethodsRoute = AuthedPaymentMethodsRouteImport.update({
  id: '/payment-methods',
  path: '/payment-methods',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPayablesRoute = AuthedPayablesRouteImport.update({
  id: '/payables',
  path: '/payables',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInventoryTransferRequestsRoute =
  AuthedInventoryTransferRequestsRouteImport.update({
    id: '/inventory-transfer-requests',
    path: '/inventory-transfer-requests',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCustomersRoute = AuthedCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCommissionsRoute = AuthedCommissionsRouteImport.update({
  id: '/commissions',
  path: '/commissions',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCashRegisterRoute = AuthedCashRegisterRouteImport.update({
  id: '/cash-register',
  path: '/cash-register',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInventoryIndexRoute = AuthedInventoryIndexRouteImport.update({
  id: '/inventory/',
  path: '/inventory/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedImportIndexRoute = AuthedImportIndexRouteImport.update({
  id: '/import/',
  path: '/import/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUsersUserIdRoute = AuthedUsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AuthedUsersRoute,
} as any)
const AuthedTransfersTransferIdRoute =
  AuthedTransfersTransferIdRouteImport.update({
    id: '/$transferId',
    path: '/$transferId',
    getParentRoute: () => AuthedTransfersRoute,
  } as any)
const AuthedSettingsTelegramRoute = AuthedSettingsTelegramRouteImport.update({
  id: '/settings/telegram',
  path: '/settings/telegram',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsCompanyRoute = AuthedSettingsCompanyRouteImport.update({
  id: '/settings/company',
  path: '/settings/company',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsCapabilitiesRoute =
  AuthedSettingsCapabilitiesRouteImport.update({
    id: '/settings/capabilities',
    path: '/settings/capabilities',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedQuotationsQuotationIdRoute =
  AuthedQuotationsQuotationIdRouteImport.update({
    id: '/$quotationId',
    path: '/$quotationId',
    getParentRoute: () => AuthedQuotationsRoute,
  } as any)
const AuthedPosArmarRoute = AuthedPosArmarRouteImport.update({
  id: '/pos_/armar',
  path: '/pos/armar',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInventoryManualMovementsRoute =
  AuthedInventoryManualMovementsRouteImport.update({
    id: '/inventory/manual-movements',
    path: '/inventory/manual-movements',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedInventoryCurrencyRoute = AuthedInventoryCurrencyRouteImport.update({
  id: '/inventory/currency',
  path: '/inventory/currency',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInventoryCatalogsRoute = AuthedInventoryCatalogsRouteImport.update({
  id: '/inventory/catalogs',
  path: '/inventory/catalogs',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInventoryAdminRoute = AuthedInventoryAdminRouteImport.update({
  id: '/inventory/admin',
  path: '/inventory/admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInventoryProductIdRoute =
  AuthedInventoryProductIdRouteImport.update({
    id: '/inventory/$productId',
    path: '/inventory/$productId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedInventoryTransferRequestsRequestIdRoute =
  AuthedInventoryTransferRequestsRequestIdRouteImport.update({
    id: '/$requestId',
    path: '/$requestId',
    getParentRoute: () => AuthedInventoryTransferRequestsRoute,
  } as any)
const AuthedAccessRolesRoute = AuthedAccessRolesRouteImport.update({
  id: '/access/roles',
  path: '/access/roles',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccessPermissionsRoute = AuthedAccessPermissionsRouteImport.update({
  id: '/access/permissions',
  path: '/access/permissions',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccessGroupsRoute = AuthedAccessGroupsRouteImport.update({
  id: '/access/groups',
  path: '/access/groups',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedImportSessionsSessionIdRoute =
  AuthedImportSessionsSessionIdRouteImport.update({
    id: '/import/sessions/$sessionId',
    path: '/import/sessions/$sessionId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAccessRolesRoleIdRoute = AuthedAccessRolesRoleIdRouteImport.update({
  id: '/$roleId',
  path: '/$roleId',
  getParentRoute: () => AuthedAccessRolesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/master': typeof MasterRouteWithChildren
  '/setup': typeof SetupRoute
  '/support': typeof SupportRoute
  '/cash-register': typeof AuthedCashRegisterRoute
  '/commissions': typeof AuthedCommissionsRoute
  '/customers': typeof AuthedCustomersRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/inventory-transfer-requests': typeof AuthedInventoryTransferRequestsRouteWithChildren
  '/payables': typeof AuthedPayablesRoute
  '/payment-methods': typeof AuthedPaymentMethodsRoute
  '/pos': typeof AuthedPosRoute
  '/printing': typeof AuthedPrintingRoute
  '/promotions': typeof AuthedPromotionsRoute
  '/purchases': typeof AuthedPurchasesRoute
  '/quotations': typeof AuthedQuotationsRouteWithChildren
  '/receivables': typeof AuthedReceivablesRoute
  '/reports': typeof AuthedReportsRoute
  '/sales': typeof AuthedSalesRoute
  '/sales-returns': typeof AuthedSalesReturnsRoute
  '/suppliers': typeof AuthedSuppliersRoute
  '/transfers': typeof AuthedTransfersRouteWithChildren
  '/users': typeof AuthedUsersRouteWithChildren
  '/warranties': typeof AuthedWarrantiesRoute
  '/workshop': typeof AuthedWorkshopRoute
  '/master/login': typeof MasterLoginRoute
  '/access/groups': typeof AuthedAccessGroupsRoute
  '/access/permissions': typeof AuthedAccessPermissionsRoute
  '/access/roles': typeof AuthedAccessRolesRouteWithChildren
  '/inventory-transfer-requests/$requestId': typeof AuthedInventoryTransferRequestsRequestIdRoute
  '/inventory/$productId': typeof AuthedInventoryProductIdRoute
  '/inventory/admin': typeof AuthedInventoryAdminRoute
  '/inventory/catalogs': typeof AuthedInventoryCatalogsRoute
  '/inventory/currency': typeof AuthedInventoryCurrencyRoute
  '/inventory/manual-movements': typeof AuthedInventoryManualMovementsRoute
  '/pos/armar': typeof AuthedPosArmarRoute
  '/quotations/$quotationId': typeof AuthedQuotationsQuotationIdRoute
  '/settings/capabilities': typeof AuthedSettingsCapabilitiesRoute
  '/settings/company': typeof AuthedSettingsCompanyRoute
  '/settings/telegram': typeof AuthedSettingsTelegramRoute
  '/transfers/$transferId': typeof AuthedTransfersTransferIdRoute
  '/users/$userId': typeof AuthedUsersUserIdRoute
  '/import/': typeof AuthedImportIndexRoute
  '/inventory/': typeof AuthedInventoryIndexRoute
  '/access/roles/$roleId': typeof AuthedAccessRolesRoleIdRoute
  '/import/sessions/$sessionId': typeof AuthedImportSessionsSessionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/master': typeof MasterRouteWithChildren
  '/setup': typeof SetupRoute
  '/support': typeof SupportRoute
  '/cash-register': typeof AuthedCashRegisterRoute
  '/commissions': typeof AuthedCommissionsRoute
  '/customers': typeof AuthedCustomersRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/inventory-transfer-requests': typeof AuthedInventoryTransferRequestsRouteWithChildren
  '/payables': typeof AuthedPayablesRoute
  '/payment-methods': typeof AuthedPaymentMethodsRoute
  '/pos': typeof AuthedPosRoute
  '/printing': typeof AuthedPrintingRoute
  '/promotions': typeof AuthedPromotionsRoute
  '/purchases': typeof AuthedPurchasesRoute
  '/quotations': typeof AuthedQuotationsRouteWithChildren
  '/receivables': typeof AuthedReceivablesRoute
  '/reports': typeof AuthedReportsRoute
  '/sales': typeof AuthedSalesRoute
  '/sales-returns': typeof AuthedSalesReturnsRoute
  '/suppliers': typeof AuthedSuppliersRoute
  '/transfers': typeof AuthedTransfersRouteWithChildren
  '/users': typeof AuthedUsersRouteWithChildren
  '/warranties': typeof AuthedWarrantiesRoute
  '/workshop': typeof AuthedWorkshopRoute
  '/master/login': typeof MasterLoginRoute
  '/access/groups': typeof AuthedAccessGroupsRoute
  '/access/permissions': typeof AuthedAccessPermissionsRoute
  '/access/roles': typeof AuthedAccessRolesRouteWithChildren
  '/inventory-transfer-requests/$requestId': typeof AuthedInventoryTransferRequestsRequestIdRoute
  '/inventory/$productId': typeof AuthedInventoryProductIdRoute
  '/inventory/admin': typeof AuthedInventoryAdminRoute
  '/inventory/catalogs': typeof AuthedInventoryCatalogsRoute
  '/inventory/currency': typeof AuthedInventoryCurrencyRoute
  '/inventory/manual-movements': typeof AuthedInventoryManualMovementsRoute
  '/pos/armar': typeof AuthedPosArmarRoute
  '/quotations/$quotationId': typeof AuthedQuotationsQuotationIdRoute
  '/settings/capabilities': typeof AuthedSettingsCapabilitiesRoute
  '/settings/company': typeof AuthedSettingsCompanyRoute
  '/settings/telegram': typeof AuthedSettingsTelegramRoute
  '/transfers/$transferId': typeof AuthedTransfersTransferIdRoute
  '/users/$userId': typeof AuthedUsersUserIdRoute
  '/import': typeof AuthedImportIndexRoute
  '/inventory': typeof AuthedInventoryIndexRoute
  '/access/roles/$roleId': typeof AuthedAccessRolesRoleIdRoute
  '/import/sessions/$sessionId': typeof AuthedImportSessionsSessionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/master': typeof MasterRouteWithChildren
  '/setup': typeof SetupRoute
  '/support': typeof SupportRoute
  '/_authed/cash-register': typeof AuthedCashRegisterRoute
  '/_authed/commissions': typeof AuthedCommissionsRoute
  '/_authed/customers': typeof AuthedCustomersRoute
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/inventory-transfer-requests': typeof AuthedInventoryTransferRequestsRouteWithChildren
  '/_authed/payables': typeof AuthedPayablesRoute
  '/_authed/payment-methods': typeof AuthedPaymentMethodsRoute
  '/_authed/pos': typeof AuthedPosRoute
  '/_authed/printing': typeof AuthedPrintingRoute
  '/_authed/promotions': typeof AuthedPromotionsRoute
  '/_authed/purchases': typeof AuthedPurchasesRoute
  '/_authed/quotations': typeof AuthedQuotationsRouteWithChildren
  '/_authed/receivables': typeof AuthedReceivablesRoute
  '/_authed/reports': typeof AuthedReportsRoute
  '/_authed/sales': typeof AuthedSalesRoute
  '/_authed/sales-returns': typeof AuthedSalesReturnsRoute
  '/_authed/suppliers': typeof AuthedSuppliersRoute
  '/_authed/transfers': typeof AuthedTransfersRouteWithChildren
  '/_authed/users': typeof AuthedUsersRouteWithChildren
  '/_authed/warranties': typeof AuthedWarrantiesRoute
  '/_authed/workshop': typeof AuthedWorkshopRoute
  '/master/login': typeof MasterLoginRoute
  '/_authed/access/groups': typeof AuthedAccessGroupsRoute
  '/_authed/access/permissions': typeof AuthedAccessPermissionsRoute
  '/_authed/access/roles': typeof AuthedAccessRolesRouteWithChildren
  '/_authed/inventory-transfer-requests/$requestId': typeof AuthedInventoryTransferRequestsRequestIdRoute
  '/_authed/inventory/$productId': typeof AuthedInventoryProductIdRoute
  '/_authed/inventory/admin': typeof AuthedInventoryAdminRoute
  '/_authed/inventory/catalogs': typeof AuthedInventoryCatalogsRoute
  '/_authed/inventory/currency': typeof AuthedInventoryCurrencyRoute
  '/_authed/inventory/manual-movements': typeof AuthedInventoryManualMovementsRoute
  '/_authed/pos_/armar': typeof AuthedPosArmarRoute
  '/_authed/quotations/$quotationId': typeof AuthedQuotationsQuotationIdRoute
  '/_authed/settings/capabilities': typeof AuthedSettingsCapabilitiesRoute
  '/_authed/settings/company': typeof AuthedSettingsCompanyRoute
  '/_authed/settings/telegram': typeof AuthedSettingsTelegramRoute
  '/_authed/transfers/$transferId': typeof AuthedTransfersTransferIdRoute
  '/_authed/users/$userId': typeof AuthedUsersUserIdRoute
  '/_authed/import/': typeof AuthedImportIndexRoute
  '/_authed/inventory/': typeof AuthedInventoryIndexRoute
  '/_authed/access/roles/$roleId': typeof AuthedAccessRolesRoleIdRoute
  '/_authed/import/sessions/$sessionId': typeof AuthedImportSessionsSessionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/master'
    | '/setup'
    | '/support'
    | '/cash-register'
    | '/commissions'
    | '/customers'
    | '/dashboard'
    | '/inventory-transfer-requests'
    | '/payables'
    | '/payment-methods'
    | '/pos'
    | '/printing'
    | '/promotions'
    | '/purchases'
    | '/quotations'
    | '/receivables'
    | '/reports'
    | '/sales'
    | '/sales-returns'
    | '/suppliers'
    | '/transfers'
    | '/users'
    | '/warranties'
    | '/workshop'
    | '/master/login'
    | '/access/groups'
    | '/access/permissions'
    | '/access/roles'
    | '/inventory-transfer-requests/$requestId'
    | '/inventory/$productId'
    | '/inventory/admin'
    | '/inventory/catalogs'
    | '/inventory/currency'
    | '/inventory/manual-movements'
    | '/pos/armar'
    | '/quotations/$quotationId'
    | '/settings/capabilities'
    | '/settings/company'
    | '/settings/telegram'
    | '/transfers/$transferId'
    | '/users/$userId'
    | '/import/'
    | '/inventory/'
    | '/access/roles/$roleId'
    | '/import/sessions/$sessionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/master'
    | '/setup'
    | '/support'
    | '/cash-register'
    | '/commissions'
    | '/customers'
    | '/dashboard'
    | '/inventory-transfer-requests'
    | '/payables'
    | '/payment-methods'
    | '/pos'
    | '/printing'
    | '/promotions'
    | '/purchases'
    | '/quotations'
    | '/receivables'
    | '/reports'
    | '/sales'
    | '/sales-returns'
    | '/suppliers'
    | '/transfers'
    | '/users'
    | '/warranties'
    | '/workshop'
    | '/master/login'
    | '/access/groups'
    | '/access/permissions'
    | '/access/roles'
    | '/inventory-transfer-requests/$requestId'
    | '/inventory/$productId'
    | '/inventory/admin'
    | '/inventory/catalogs'
    | '/inventory/currency'
    | '/inventory/manual-movements'
    | '/pos/armar'
    | '/quotations/$quotationId'
    | '/settings/capabilities'
    | '/settings/company'
    | '/settings/telegram'
    | '/transfers/$transferId'
    | '/users/$userId'
    | '/import'
    | '/inventory'
    | '/access/roles/$roleId'
    | '/import/sessions/$sessionId'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/login'
    | '/master'
    | '/setup'
    | '/support'
    | '/_authed/cash-register'
    | '/_authed/commissions'
    | '/_authed/customers'
    | '/_authed/dashboard'
    | '/_authed/inventory-transfer-requests'
    | '/_authed/payables'
    | '/_authed/payment-methods'
    | '/_authed/pos'
    | '/_authed/printing'
    | '/_authed/promotions'
    | '/_authed/purchases'
    | '/_authed/quotations'
    | '/_authed/receivables'
    | '/_authed/reports'
    | '/_authed/sales'
    | '/_authed/sales-returns'
    | '/_authed/suppliers'
    | '/_authed/transfers'
    | '/_authed/users'
    | '/_authed/warranties'
    | '/_authed/workshop'
    | '/master/login'
    | '/_authed/access/groups'
    | '/_authed/access/permissions'
    | '/_authed/access/roles'
    | '/_authed/inventory-transfer-requests/$requestId'
    | '/_authed/inventory/$productId'
    | '/_authed/inventory/admin'
    | '/_authed/inventory/catalogs'
    | '/_authed/inventory/currency'
    | '/_authed/inventory/manual-movements'
    | '/_authed/pos_/armar'
    | '/_authed/quotations/$quotationId'
    | '/_authed/settings/capabilities'
    | '/_authed/settings/company'
    | '/_authed/settings/telegram'
    | '/_authed/transfers/$transferId'
    | '/_authed/users/$userId'
    | '/_authed/import/'
    | '/_authed/inventory/'
    | '/_authed/access/roles/$roleId'
    | '/_authed/import/sessions/$sessionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  MasterRoute: typeof MasterRouteWithChildren
  SetupRoute: typeof SetupRoute
  SupportRoute: typeof SupportRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/master': {
      id: '/master'
      path: '/master'
      fullPath: '/master'
      preLoaderRoute: typeof MasterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/master/login': {
      id: '/master/login'
      path: '/login'
      fullPath: '/master/login'
      preLoaderRoute: typeof MasterLoginRouteImport
      parentRoute: typeof MasterRoute
    }
    '/_authed/workshop': {
      id: '/_authed/workshop'
      path: '/workshop'
      fullPath: '/workshop'
      preLoaderRoute: typeof AuthedWorkshopRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/warranties': {
      id: '/_authed/warranties'
      path: '/warranties'
      fullPath: '/warranties'
      preLoaderRoute: typeof AuthedWarrantiesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users': {
      id: '/_authed/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthedUsersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/transfers': {
      id: '/_authed/transfers'
      path: '/transfers'
      fullPath: '/transfers'
      preLoaderRoute: typeof AuthedTransfersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/suppliers': {
      id: '/_authed/suppliers'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof AuthedSuppliersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/sales-returns': {
      id: '/_authed/sales-returns'
      path: '/sales-returns'
      fullPath: '/sales-returns'
      preLoaderRoute: typeof AuthedSalesReturnsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/sales': {
      id: '/_authed/sales'
      path: '/sales'
      fullPath: '/sales'
      preLoaderRoute: typeof AuthedSalesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/reports': {
      id: '/_authed/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthedReportsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/receivables': {
      id: '/_authed/receivables'
      path: '/receivables'
      fullPath: '/receivables'
      preLoaderRoute: typeof AuthedReceivablesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/quotations': {
      id: '/_authed/quotations'
      path: '/quotations'
      fullPath: '/quotations'
      preLoaderRoute: typeof AuthedQuotationsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/purchases': {
      id: '/_authed/purchases'
      path: '/purchases'
      fullPath: '/purchases'
      preLoaderRoute: typeof AuthedPurchasesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/promotions': {
      id: '/_authed/promotions'
      path: '/promotions'
      fullPath: '/promotions'
      preLoaderRoute: typeof AuthedPromotionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/printing': {
      id: '/_authed/printing'
      path: '/printing'
      fullPath: '/printing'
      preLoaderRoute: typeof AuthedPrintingRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/pos': {
      id: '/_authed/pos'
      path: '/pos'
      fullPath: '/pos'
      preLoaderRoute: typeof AuthedPosRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/payment-methods': {
      id: '/_authed/payment-methods'
      path: '/payment-methods'
      fullPath: '/payment-methods'
      preLoaderRoute: typeof AuthedPaymentMethodsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/payables': {
      id: '/_authed/payables'
      path: '/payables'
      fullPath: '/payables'
      preLoaderRoute: typeof AuthedPayablesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/inventory-transfer-requests': {
      id: '/_authed/inventory-transfer-requests'
      path: '/inventory-transfer-requests'
      fullPath: '/inventory-transfer-requests'
      preLoaderRoute: typeof AuthedInventoryTransferRequestsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/customers': {
      id: '/_authed/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthedCustomersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/commissions': {
      id: '/_authed/commissions'
      path: '/commissions'
      fullPath: '/commissions'
      preLoaderRoute: typeof AuthedCommissionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/cash-register': {
      id: '/_authed/cash-register'
      path: '/cash-register'
      fullPath: '/cash-register'
      preLoaderRoute: typeof AuthedCashRegisterRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/inventory/': {
      id: '/_authed/inventory/'
      path: '/inventory'
      fullPath: '/inventory/'
      preLoaderRoute: typeof AuthedInventoryIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/import/': {
      id: '/_authed/import/'
      path: '/import'
      fullPath: '/import/'
      preLoaderRoute: typeof AuthedImportIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users/$userId': {
      id: '/_authed/users/$userId'
      path: '/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthedUsersUserIdRouteImport
      parentRoute: typeof AuthedUsersRoute
    }
    '/_authed/transfers/$transferId': {
      id: '/_authed/transfers/$transferId'
      path: '/$transferId'
      fullPath: '/transfers/$transferId'
      preLoaderRoute: typeof AuthedTransfersTransferIdRouteImport
      parentRoute: typeof AuthedTransfersRoute
    }
    '/_authed/settings/telegram': {
      id: '/_authed/settings/telegram'
      path: '/settings/telegram'
      fullPath: '/settings/telegram'
      preLoaderRoute: typeof AuthedSettingsTelegramRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/company': {
      id: '/_authed/settings/company'
      path: '/settings/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof AuthedSettingsCompanyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/capabilities': {
      id: '/_authed/settings/capabilities'
      path: '/settings/capabilities'
      fullPath: '/settings/capabilities'
      preLoaderRoute: typeof AuthedSettingsCapabilitiesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/quotations/$quotationId': {
      id: '/_authed/quotations/$quotationId'
      path: '/$quotationId'
      fullPath: '/quotations/$quotationId'
      preLoaderRoute: typeof AuthedQuotationsQuotationIdRouteImport
      parentRoute: typeof AuthedQuotationsRoute
    }
    '/_authed/pos_/armar': {
      id: '/_authed/pos_/armar'
      path: '/pos/armar'
      fullPath: '/pos/armar'
      preLoaderRoute: typeof AuthedPosArmarRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/inventory/manual-movements': {
      id: '/_authed/inventory/manual-movements'
      path: '/inventory/manual-movements'
      fullPath: '/inventory/manual-movements'
      preLoaderRoute: typeof AuthedInventoryManualMovementsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/inventory/currency': {
      id: '/_authed/inventory/currency'
      path: '/inventory/currency'
      fullPath: '/inventory/currency'
      preLoaderRoute: typeof AuthedInventoryCurrencyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/inventory/catalogs': {
      id: '/_authed/inventory/catalogs'
      path: '/inventory/catalogs'
      fullPath: '/inventory/catalogs'
      preLoaderRoute: typeof AuthedInventoryCatalogsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/inventory/admin': {
      id: '/_authed/inventory/admin'
      path: '/inventory/admin'
      fullPath: '/inventory/admin'
      preLoaderRoute: typeof AuthedInventoryAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/inventory/$productId': {
      id: '/_authed/inventory/$productId'
      path: '/inventory/$productId'
      fullPath: '/inventory/$productId'
      preLoaderRoute: typeof AuthedInventoryProductIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/inventory-transfer-requests/$requestId': {
      id: '/_authed/inventory-transfer-requests/$requestId'
      path: '/$requestId'
      fullPath: '/inventory-transfer-requests/$requestId'
      preLoaderRoute: typeof AuthedInventoryTransferRequestsRequestIdRouteImport
      parentRoute: typeof AuthedInventoryTransferRequestsRoute
    }
    '/_authed/access/roles': {
      id: '/_authed/access/roles'
      path: '/access/roles'
      fullPath: '/access/roles'
      preLoaderRoute: typeof AuthedAccessRolesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/access/permissions': {
      id: '/_authed/access/permissions'
      path: '/access/permissions'
      fullPath: '/access/permissions'
      preLoaderRoute: typeof AuthedAccessPermissionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/access/groups': {
      id: '/_authed/access/groups'
      path: '/access/groups'
      fullPath: '/access/groups'
      preLoaderRoute: typeof AuthedAccessGroupsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/import/sessions/$sessionId': {
      id: '/_authed/import/sessions/$sessionId'
      path: '/import/sessions/$sessionId'
      fullPath: '/import/sessions/$sessionId'
      preLoaderRoute: typeof AuthedImportSessionsSessionIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/access/roles/$roleId': {
      id: '/_authed/access/roles/$roleId'
      path: '/$roleId'
      fullPath: '/access/roles/$roleId'
      preLoaderRoute: typeof AuthedAccessRolesRoleIdRouteImport
      parentRoute: typeof AuthedAccessRolesRoute
    }
  }
}

interface AuthedInventoryTransferRequestsRouteChildren {
  AuthedInventoryTransferRequestsRequestIdRoute: typeof AuthedInventoryTransferRequestsRequestIdRoute
}

const AuthedInventoryTransferRequestsRouteChildren: AuthedInventoryTransferRequestsRouteChildren =
  {
    AuthedInventoryTransferRequestsRequestIdRoute:
      AuthedInventoryTransferRequestsRequestIdRoute,
  }

const AuthedInventoryTransferRequestsRouteWithChildren =
  AuthedInventoryTransferRequestsRoute._addFileChildren(
    AuthedInventoryTransferRequestsRouteChildren,
  )

interface AuthedQuotationsRouteChildren {
  AuthedQuotationsQuotationIdRoute: typeof AuthedQuotationsQuotationIdRoute
}

const AuthedQuotationsRouteChildren: AuthedQuotationsRouteChildren = {
  AuthedQuotationsQuotationIdRoute: AuthedQuotationsQuotationIdRoute,
}

const AuthedQuotationsRouteWithChildren =
  AuthedQuotationsRoute._addFileChildren(AuthedQuotationsRouteChildren)

interface AuthedTransfersRouteChildren {
  AuthedTransfersTransferIdRoute: typeof AuthedTransfersTransferIdRoute
}

const AuthedTransfersRouteChildren: AuthedTransfersRouteChildren = {
  AuthedTransfersTransferIdRoute: AuthedTransfersTransferIdRoute,
}

const AuthedTransfersRouteWithChildren = AuthedTransfersRoute._addFileChildren(
  AuthedTransfersRouteChildren,
)

interface AuthedUsersRouteChildren {
  AuthedUsersUserIdRoute: typeof AuthedUsersUserIdRoute
}

const AuthedUsersRouteChildren: AuthedUsersRouteChildren = {
  AuthedUsersUserIdRoute: AuthedUsersUserIdRoute,
}

const AuthedUsersRouteWithChildren = AuthedUsersRoute._addFileChildren(
  AuthedUsersRouteChildren,
)

interface AuthedAccessRolesRouteChildren {
  AuthedAccessRolesRoleIdRoute: typeof AuthedAccessRolesRoleIdRoute
}

const AuthedAccessRolesRouteChildren: AuthedAccessRolesRouteChildren = {
  AuthedAccessRolesRoleIdRoute: AuthedAccessRolesRoleIdRoute,
}

const AuthedAccessRolesRouteWithChildren =
  AuthedAccessRolesRoute._addFileChildren(AuthedAccessRolesRouteChildren)

interface AuthedRouteChildren {
  AuthedCashRegisterRoute: typeof AuthedCashRegisterRoute
  AuthedCommissionsRoute: typeof AuthedCommissionsRoute
  AuthedCustomersRoute: typeof AuthedCustomersRoute
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedInventoryTransferRequestsRoute: typeof AuthedInventoryTransferRequestsRouteWithChildren
  AuthedPayablesRoute: typeof AuthedPayablesRoute
  AuthedPaymentMethodsRoute: typeof AuthedPaymentMethodsRoute
  AuthedPosRoute: typeof AuthedPosRoute
  AuthedPrintingRoute: typeof AuthedPrintingRoute
  AuthedPromotionsRoute: typeof AuthedPromotionsRoute
  AuthedPurchasesRoute: typeof AuthedPurchasesRoute
  AuthedQuotationsRoute: typeof AuthedQuotationsRouteWithChildren
  AuthedReceivablesRoute: typeof AuthedReceivablesRoute
  AuthedReportsRoute: typeof AuthedReportsRoute
  AuthedSalesRoute: typeof AuthedSalesRoute
  AuthedSalesReturnsRoute: typeof AuthedSalesReturnsRoute
  AuthedSuppliersRoute: typeof AuthedSuppliersRoute
  AuthedTransfersRoute: typeof AuthedTransfersRouteWithChildren
  AuthedUsersRoute: typeof AuthedUsersRouteWithChildren
  AuthedWarrantiesRoute: typeof AuthedWarrantiesRoute
  AuthedWorkshopRoute: typeof AuthedWorkshopRoute
  AuthedAccessGroupsRoute: typeof AuthedAccessGroupsRoute
  AuthedAccessPermissionsRoute: typeof AuthedAccessPermissionsRoute
  AuthedAccessRolesRoute: typeof AuthedAccessRolesRouteWithChildren
  AuthedInventoryProductIdRoute: typeof AuthedInventoryProductIdRoute
  AuthedInventoryAdminRoute: typeof AuthedInventoryAdminRoute
  AuthedInventoryCatalogsRoute: typeof AuthedInventoryCatalogsRoute
  AuthedInventoryCurrencyRoute: typeof AuthedInventoryCurrencyRoute
  AuthedInventoryManualMovementsRoute: typeof AuthedInventoryManualMovementsRoute
  AuthedPosArmarRoute: typeof AuthedPosArmarRoute
  AuthedSettingsCapabilitiesRoute: typeof AuthedSettingsCapabilitiesRoute
  AuthedSettingsCompanyRoute: typeof AuthedSettingsCompanyRoute
  AuthedSettingsTelegramRoute: typeof AuthedSettingsTelegramRoute
  AuthedImportIndexRoute: typeof AuthedImportIndexRoute
  AuthedInventoryIndexRoute: typeof AuthedInventoryIndexRoute
  AuthedImportSessionsSessionIdRoute: typeof AuthedImportSessionsSessionIdRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedCashRegisterRoute: AuthedCashRegisterRoute,
  AuthedCommissionsRoute: AuthedCommissionsRoute,
  AuthedCustomersRoute: AuthedCustomersRoute,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedInventoryTransferRequestsRoute:
    AuthedInventoryTransferRequestsRouteWithChildren,
  AuthedPayablesRoute: AuthedPayablesRoute,
  AuthedPaymentMethodsRoute: AuthedPaymentMethodsRoute,
  AuthedPosRoute: AuthedPosRoute,
  AuthedPrintingRoute: AuthedPrintingRoute,
  AuthedPromotionsRoute: AuthedPromotionsRoute,
  AuthedPurchasesRoute: AuthedPurchasesRoute,
  AuthedQuotationsRoute: AuthedQuotationsRouteWithChildren,
  AuthedReceivablesRoute: AuthedReceivablesRoute,
  AuthedReportsRoute: AuthedReportsRoute,
  AuthedSalesRoute: AuthedSalesRoute,
  AuthedSalesReturnsRoute: AuthedSalesReturnsRoute,
  AuthedSuppliersRoute: AuthedSuppliersRoute,
  AuthedTransfersRoute: AuthedTransfersRouteWithChildren,
  AuthedUsersRoute: AuthedUsersRouteWithChildren,
  AuthedWarrantiesRoute: AuthedWarrantiesRoute,
  AuthedWorkshopRoute: AuthedWorkshopRoute,
  AuthedAccessGroupsRoute: AuthedAccessGroupsRoute,
  AuthedAccessPermissionsRoute: AuthedAccessPermissionsRoute,
  AuthedAccessRolesRoute: AuthedAccessRolesRouteWithChildren,
  AuthedInventoryProductIdRoute: AuthedInventoryProductIdRoute,
  AuthedInventoryAdminRoute: AuthedInventoryAdminRoute,
  AuthedInventoryCatalogsRoute: AuthedInventoryCatalogsRoute,
  AuthedInventoryCurrencyRoute: AuthedInventoryCurrencyRoute,
  AuthedInventoryManualMovementsRoute: AuthedInventoryManualMovementsRoute,
  AuthedPosArmarRoute: AuthedPosArmarRoute,
  AuthedSettingsCapabilitiesRoute: AuthedSettingsCapabilitiesRoute,
  AuthedSettingsCompanyRoute: AuthedSettingsCompanyRoute,
  AuthedSettingsTelegramRoute: AuthedSettingsTelegramRoute,
  AuthedImportIndexRoute: AuthedImportIndexRoute,
  AuthedInventoryIndexRoute: AuthedInventoryIndexRoute,
  AuthedImportSessionsSessionIdRoute: AuthedImportSessionsSessionIdRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface MasterRouteChildren {
  MasterLoginRoute: typeof MasterLoginRoute
}

const MasterRouteChildren: MasterRouteChildren = {
  MasterLoginRoute: MasterLoginRoute,
}

const MasterRouteWithChildren =
  MasterRoute._addFileChildren(MasterRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  MasterRoute: MasterRouteWithChildren,
  SetupRoute: SetupRoute,
  SupportRoute: SupportRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
